// extracted by mini-css-extract-plugin
export var container = "_gs-0";
export var content = "_gs-3";
export var customerTitle = "_gs-4";
export var empty = "_gs-5";
export var gray = "_gs-6";
export var header = "_gs-7";
export var info = "_gs-8";
export var loading = "_gs-2";
export var loadingCard = "_gs-9";
export var oneLine = "_gs-a";
export var personName = "_gs-e";
export var pillContainer = "_gs-b";
export var selected = "_gs-1";
export var text = "_gs-c";
export var twoLines = "_gs-d";
export var unread = "_gs-f";
export var unreadIndicator = "_gs-g";